<!--
*      0 = Pending, Reservation created but client did not confirm it. (Client will get first email)
*      1 = Reserved, Reservation confirmed by client. (Reservation is active)
*      2 = Approved, Lido approve reservation. (Reservation convert to counter)
*      3 = Expired, client did not appear or came late to lido.
*      4 = Cancelled by client.
*      5 = Soft delete.
-->
<div class="list-group-item border-left-width mb-1" [ngClass]="'border-left-status-' + reservation.status">
    <div class="item-label">{{'USER.RESERVATIONS.ITEM.status-'+ reservation.status | translate}} </div>
    <div class="row">
        <div [ngClass]="{'col-12 col-md-11': reservation.status === 1, 'col-12': reservation.status !== 1}">
            <div class="d-flex w-100 justify-content-between">
                <h4 class="mb-1">{{reservation.firstName}} {{reservation.lastName}}</h4>
                <small> {{'USER.RESERVATIONS.ITEM.reservationCode' | translate}} <br />
                    <strong>{{reservation.reservationCode}}</strong></small>
            </div>
            <hr />
            <div class="row">
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.persons' | translate}} : </strong>
                    <p class="m-0">{{reservation.reservedPersons}}</p>
                </div>
                <div class="col">
                    <strong> {{'USER.RESERVATIONS.ITEM.expiredAt' | translate}} : </strong>
                    <p class="m-0">{{reservation.expiredTimeAt}}</p>
                </div>
            </div>
            <hr />
            <div class="form-group">
                <strong> {{'USER.RESERVATIONS.ITEM.comment' | translate}} : </strong>
                <p class="help-text">{{reservation.comment}}</p>
            </div>
        </div>
        <div class="col-1 justify-content-between text-center d-none d-sm-block" *ngIf="reservation.status === 1">
            <button type="button" class="btn btn-link" (click)="onReservationApproveClick(index)">
                <fa-icon [icon]="icons['faCheck']" style="line-height: 11rem; font-size: 24px;"></fa-icon>
            </button>
        </div>
    </div>
</div>
